module.exports = __webpack_public_path__ + "static/media/card-design-from-metoyou.35a778f3.png";